import { defineMessages } from '@/i18n'

/** Тексты редакторов блоков (панель справа) и окна «Добавить блок». */
export const messages = defineMessages({
  ru: {
    a11yRemove: 'Удалить',
    close: 'Закрыть',
    addBlock: 'Добавить блок',
    chooseContentType: 'Выберите тип контента',
    sectionContent: 'Контент',
    sectionInteractive: 'Интерактивные',
    groupTheory: 'Теоретические',
    groupPractice: 'Практические',
    blockedInPractical: 'Недоступно в практическом уроке',
    addScreen: (label: string) => `Добавить блок «${label}»`,
    add: 'Добавить',
    comingSoon: 'Скоро',
    cancel: 'Отмена',
    noRights: 'Нет прав',
    articleUnpublished: 'Статья снята с публикации',
    articleUnpublishedHint: 'Юзеры её не увидят. Замените на другую опубликованную статью.',
    changeArticle: 'Поменять статью',
    multiCorrect: 'Несколько правильных',
    singleCorrect: 'Один правильный',
    question: 'Вопрос',
    questionPlaceholder: 'Введите вопрос...',
    answerOptions: 'Варианты ответа',
    addAnswer: 'Добавить ответ',
    notAvailableYet: 'Пока недоступно',
    disabledTypePrefix: 'Блок типа',
    disabledTypeSuffix: 'ещё в разработке. Скоро.',
    deleteBlock: 'Удалить блок',
    answerVariants: 'Варианты ответов',
    addVariant: 'Добавить вариант',
    fillBlankFeedbackPlaceholder: 'Например: Неверно — столица Франции Париж, а не Лион.',
    oneGapOnly: 'Оставьте ровно один пропуск ___',
    statement: 'Утверждение',
    fillBlankPlaceholder: 'Например: Столица Франции — ___',
    addGap: 'Добавить пропуск',
    image: 'Изображение',
    infoImageHint:
      'Лучше всего подходит вертикальная картинка 9:16 — она займёт весь экран. Картинка другого формата растянется на весь экран, а то, что не поместится, обрежется по краям.',
    pairs: 'Пары',
    leftPart: 'Левая часть',
    rightPart: 'Правая часть',
    addPair: 'Добавить пару',
    answer: 'Ответ',
    correctAnswer: 'Правильный ответ',
    regex: 'Регулярка',
    matchByRegex: 'Сверять по regex',
    markCorrect: 'Отметить как правильный',
    variantN: (n: number) => `Вариант ${n}`,
    feedbackPlaceholder:
      'Например: Неверно — зелёный чай заваривают при 80°C, а не кипятком, иначе он горчит.',
    incorrectFeedback: 'Отклик на неверный ответ',
    optional: '(опционально)',
    videoDeleteFailed: 'Не удалось удалить видео',
    video: 'Видео',
    videoHint: 'Подходят вертикальные (9:16) и горизонтальные (16:9) видео.',
    poster: 'Постер',
    chapters: 'Главы',
    yes: 'Да',
    no: 'Нет',
    statementPlaceholder: 'Введите утверждение...',
  },
  en: {
    a11yRemove: 'Remove',
    close: 'Close',
    addBlock: 'Add block',
    chooseContentType: 'Choose a content type',
    sectionContent: 'Content',
    sectionInteractive: 'Interactive',
    groupTheory: 'Theory',
    groupPractice: 'Practice',
    blockedInPractical: 'Not available in a practice lesson',
    addScreen: (label: string) => `Add “${label}” block`,
    add: 'Add',
    comingSoon: 'Coming soon',
    cancel: 'Cancel',
    noRights: 'No permission',
    articleUnpublished: 'Article unpublished',
    articleUnpublishedHint: 'Learners won’t see it. Replace it with another published article.',
    changeArticle: 'Change article',
    multiCorrect: 'Multiple answers',
    singleCorrect: 'Single answer',
    question: 'Question',
    questionPlaceholder: 'Enter a question...',
    answerOptions: 'Answer options',
    addAnswer: 'Add answer',
    notAvailableYet: 'Not available yet',
    disabledTypePrefix: 'Block type',
    disabledTypeSuffix: 'is still in development. Coming soon.',
    deleteBlock: 'Delete block',
    answerVariants: 'Answer options',
    addVariant: 'Add option',
    fillBlankFeedbackPlaceholder: 'E.g. Incorrect — the capital of France is Paris, not Lyon.',
    oneGapOnly: 'Leave exactly one blank ___',
    statement: 'Statement',
    fillBlankPlaceholder: 'E.g. The capital of France is ___',
    addGap: 'Add blank',
    image: 'Image',
    infoImageHint:
      'A vertical 9:16 image works best — it fills the whole screen. Images in other formats are stretched to fill the screen, and anything that doesn’t fit is cropped at the edges.',
    pairs: 'Pairs',
    leftPart: 'Left side',
    rightPart: 'Right side',
    addPair: 'Add pair',
    answer: 'Answer',
    correctAnswer: 'Correct answer',
    regex: 'Regex',
    matchByRegex: 'Match by regex',
    markCorrect: 'Mark as correct',
    variantN: (n: number) => `Option ${n}`,
    feedbackPlaceholder:
      'E.g. Incorrect — green tea is brewed at 80°C, not with boiling water, or it turns bitter.',
    incorrectFeedback: 'Feedback for a wrong answer',
    optional: '(optional)',
    videoDeleteFailed: 'Couldn’t delete the video',
    video: 'Video',
    videoHint: 'Vertical (9:16) and horizontal (16:9) videos are supported.',
    poster: 'Poster',
    chapters: 'Chapters',
    yes: 'Yes',
    no: 'No',
    statementPlaceholder: 'Enter a statement...',
  },
})
